module.exports = __webpack_public_path__ + "static/media/tenanticon.a9ef0579.svg";